import { useState } from "react";
import { useEffect } from "react";
import Navbar from "../components/Navbar";
import jwt_decode from "jwt-decode";
import { isUserValid, loginOAuth } from "../lib/pocketbase";

const AuthButton = () => {
    const [user, setUser] = useState({});

    function handleCallbackResponse(response) {
        //console.log("Encoded JWT ID Token: " + response.credential);
        var userObject = jwt_decode(response.credential);
        console.log(userObject);
        setUser(userObject);
        document.getElementById("customSignInButton").hidden = true;
    }

    function handleSignout(event) {
        setUser({});
        document.getElementById("customSignOutButton").hidden = true;
    }

    useEffect(() => {
        /* global google */
        google.accounts.id.initialize({
            client_id: "308462231943-0hlh6avg60olgs7lmoe93pqaiqe2hme0.apps.googleusercontent.com",
            callback: handleCallbackResponse
        });
    }, []);

    return (
        <div>

        <label htmlFor="my_modal_7" className="btn btn-ghost normal-case mr-5 text-xl px-3 py-2">Sign In</label>
{/* 
            {Object.keys(user).length === 0 && (
                <button
                    id="customSignInButton"
                    className="btn btn-secondary normal-case mr-5 text-xl px-3 py-2"
                    onClick={() => google.accounts.id.prompt()}
                >
                    Sign In
                </button>
            )} */}
        </div>
    );
}

export default AuthButton;